import script from "./EventModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventModal.vue?vue&type=script&setup=true&lang=ts"

import "./EventModal.vue?vue&type=style&index=0&id=7c58d2de&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c58d2de"]])

export default __exports__